import type { ColumnVisibilityOverrides } from './types';

const STORAGE_VERSION = 1;
const EMPTY_OVERRIDES: ColumnVisibilityOverrides = { hidden: [], shown: [] };

const getStorageKey = (storageKey: string) => `collection-columns:${storageKey}`;

const removeStoredOverrides = (storageKey: string) => {
  try {
    localStorage.removeItem(getStorageKey(storageKey));
  } catch {
    // Storage may be unavailable.
  }
};

const isIdList = (value: unknown): value is string[] =>
  Array.isArray(value) && value.every(item => typeof item === 'string');

export const readColumnVisibilityOverrides = (storageKey: string): ColumnVisibilityOverrides => {
  const key = getStorageKey(storageKey);
  try {
    const storedValue = localStorage.getItem(key);
    if (storedValue === null) return EMPTY_OVERRIDES;

    const parsed = JSON.parse(storedValue);
    const isValid = parsed?.version === STORAGE_VERSION && isIdList(parsed.hidden) && isIdList(parsed.shown);

    if (isValid) return { hidden: parsed.hidden, shown: parsed.shown };

    removeStoredOverrides(storageKey);
    return EMPTY_OVERRIDES;
  } catch {
    removeStoredOverrides(storageKey);
    return EMPTY_OVERRIDES;
  }
};

export const writeColumnVisibilityOverrides = (storageKey: string, { hidden, shown }: ColumnVisibilityOverrides) => {
  try {
    if (hidden.length === 0 && shown.length === 0) {
      removeStoredOverrides(storageKey);
    } else {
      localStorage.setItem(getStorageKey(storageKey), JSON.stringify({ version: STORAGE_VERSION, hidden, shown }));
    }
  } catch {}
};
